module.exports = __webpack_public_path__ + "img/w-miscellaneous.0ce77497.svg";